<script>

import config from '@/common/genericPanelConf';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';
import Service from '@/services/planning'
import Utils from '@/common/Utils';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable
    },
    data(){
        return{
            configuration: null,
            cloneDialogVisible: false,
            cloneParams: {
                monthDateFrom: null,
                monthDateTo: null
            }
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        showCloneFamilyPoolConfiguration(){
            this.cloneDialogVisible = true;
        },
        cloneFamilyPoolConfiguration(){
            let body = {
                monthDateFrom: Utils.formatDateForAPI(this.cloneParams.monthDateFrom),
                monthDateTo: Utils.formatDateForAPI(this.cloneParams.monthDateTo)
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.cloneFamilyPoolConfiguration(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.import_message_success'), life: 3000});
                    this.cloneDialogVisible = false;
                } else{
                    this.$toast.add({ detail: response.message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        }
    },
    computed: {
        conf(){
            return config;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    }
}
</script>



<template>
    
    <Dialog v-model:visible="cloneDialogVisible" :style="{ width: '350px' }" modal>
        <div class="grid">
            <div class="col-12 lg:col-6">
                <label for="month">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="'MM/YYYY'"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="cloneParams.monthDateFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div class="col-12 lg:col-6">
                <label for="month">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-inputtext-sm w-full': true}"
                    :placeholder="'MM/YYYY'"
                    view="month" dateFormat="mm/yy"
                    :showTime="false"
                    v-model="cloneParams.monthDateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
        </div>
        <div class="flex justify-content-end gap-2">
            <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="cloneDialogVisible = false"></Button>
            <Button type="button" class="m-2" :label="$t('btn.clone')" icon="pi pi-save" @click="cloneFamilyPoolConfiguration" 
            v-if="!uiPermissions('cloneFamilyPoolConfigurationButton').isHidden" ></Button>
        </div>
    </Dialog> 
    <div class="" style="height: 80vh;">
        <GenericDataTable :configuration="configuration" :category="category" :name="name" @on-clone-family-pool-configuration="showCloneFamilyPoolConfiguration"/>
    </div>
</template>